/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildMemoDto } from '../../models/child-memo-dto';
import { UpdateChildMemoDto } from '../../models/update-child-memo-dto';

export interface UserChildMemoControllerUpdateGuardianCounselingMemo$Params {
  memoId: string;
  centerId: string;
  guardianUserId?: any;
  teacherUserId?: any;
      body: UpdateChildMemoDto
}

export function userChildMemoControllerUpdateGuardianCounselingMemo(http: HttpClient, rootUrl: string, params: UserChildMemoControllerUpdateGuardianCounselingMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildMemoDto>> {
  const rb = new RequestBuilder(rootUrl, userChildMemoControllerUpdateGuardianCounselingMemo.PATH, 'patch');
  if (params) {
    rb.path('memoId', params.memoId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('guardianUserId', params.guardianUserId, {});
    rb.query('teacherUserId', params.teacherUserId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildMemoDto>;
    })
  );
}

userChildMemoControllerUpdateGuardianCounselingMemo.PATH = '/api/child-memo/user/guardian-counseling/{memoId}';
